import React from 'react';
import { ColorScheme, theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { CustomizedSwitches, ISwitchProps } from '../Switch/Switch';
import { ToolTip } from '../Tip/ToolTip';
import { isEmptyValue } from '../../utils/lodash';
import { StyledBadge } from '../StyledBadge';
import { FormLabel } from '@mui/material';

export interface ICustomHeaderWithStatus {
    headerTitle: string;
    field: string;
    state: Record<string, any>;
    themeStyle: ColorScheme;
    headerToolTip?: string;
    isRequired?: boolean;
    switchType?: boolean;
    switchProps?: ISwitchProps;
    style?: React.CSSProperties;
}

export const CustomHeaderWithStatus = ({
    headerTitle,
    headerToolTip,
    isRequired,
    themeStyle,
    field,
    state,
    switchType,
    switchProps,
    style,
}: ICustomHeaderWithStatus): JSX.Element => {
    const coreSegment = (
        <>
            {headerTitle} {headerToolTip && <ToolTip text={headerToolTip} />}{' '}
            <StyledBadge
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                overlap="circular"
                invisible={!isRequired}
                variant="dot"
                sx={{
                    height: '20px',
                    width: '20px',
                }}
                errorState={isEmptyValue(state[field])}
            />
        </>
    );
    if (switchType) {
        return (
            <FormLabel
                style={{
                    textAlign: 'left',
                    fontSize: 14,
                    fontStyle: 'normal',
                    fontWeight: '400',
                    color: theme[themeStyle].form_label,
                    fontFamily: FONT_ENUM.MAIN_BOLD,
                    display: 'flex',
                    alignItems: 'center',
                    border: 'none',
                    marginBottom: '8px',
                    ...style,
                }}
                component={'span'}>
                <CustomizedSwitches
                    {...switchProps}
                    style={{
                        textAlign: 'left',
                        fontSize: 14,
                        fontStyle: 'normal',
                        fontWeight: '400',
                        color: theme[themeStyle].form_label,
                        fontFamily: FONT_ENUM.MAIN_BOLD,
                        display: 'flex',
                        alignItems: 'center',
                        border: 'none',
                    }}
                />
                {coreSegment}
            </FormLabel>
        );
    }
    return (
        <FormLabel
            style={{
                textAlign: 'left',
                fontSize: 14,
                fontStyle: 'normal',
                fontWeight: '400',
                color: theme[themeStyle].form_label,
                fontFamily: FONT_ENUM.MAIN_BOLD,
                display: 'flex',
                alignItems: 'center',
                border: 'none',
                ...style,
            }}
            component={'span'}>
            {coreSegment}
        </FormLabel>
    );
};
